// import axios from "axios";
import service from "@/utils/request";
import axios from "axios";

// export const add =(datas)=>{
// return axios({
//   method:'post',
//   url:`${baseUrl}/api/ttg/columns`,
//   data:datas
// })
// }

export const adds =(data)=>{
  return service({
    method:'get',
    params:data,
    url:'/api/ttg/columns',

  })
  }
  export const us =(data)=>{
    return service({
      method:'get',
      params:data,
      url:'/api/ttg/page',
  
    })
    }
    export const options =(data)=>{
      return service({
        method:'get',
        params:data,
        url:'/api/ttg/options',
    
      })
    }

    export const pageList =(data)=>{
      return service({
        method:'get',
        params:data,
        url:'/api/ttg/page/list',
    
      })
    }
    export const detail =(data)=>{
      return service({
        method:'get',
        params:data,
        url:'/api/ttg/detail',
    
      })
    }
    


// WEBPACK FOOTER //
// ./src/api/index.js